import { gql } from '@apollo/client';

/**
 * GraphQL mutation to update a standard policy
 */
export const UPDATE_STANDARD_POLICY = gql`
  mutation UpdateStandardPolicy($policyId: ID!, $input: UpdateStandardPolicyInput!) {
    updateStandardPolicy(policyId: $policyId, input: $input) {
      id
      communityId
      name
      description
      isEnabled
      labels {
        labelId
        severity
        scoreThreshold
      }
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
      scope
      isSystemManaged
      sourcePolicyId
    }
  }
`;
